export default __webpack_public_path__ + "static/media/close_circle.95ebfdd2.svg";